import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=60610f0a&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=60610f0a&scoped=true&lang=css&"
import style1 from "./Setting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60610f0a",
  null
  
)

export default component.exports